import { UntypedFormControl } from "@angular/forms";

export function topOfCementMdRequired(control: UntypedFormControl) {
    const topOfCementMd = control.value;
    const hasCement = control.parent && control.parent.controls['hasCement'].value;
    const hangerMd = control.parent && control.parent.controls['hangerMd'].value;
    const shoeMd = control.parent && control.parent.controls['shoeMd'].value;
    if (!hasCement || control.pristine || topOfCementMd === null || topOfCementMd === undefined || topOfCementMd === 0) {
      return null;
    }
    if(hasCement && topOfCementMd < hangerMd){
       return {error: "Top of cement must be set at or below the hanger"};
    } else if(hasCement && topOfCementMd > shoeMd) {
      return {error: "Top of cement must be set at or above the shoe"};
    }
    return null;
  }
  